import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1ac2d4',
      contrastText: '#fff',
    },
    error: {
      main: '#f00',
      contrastText: '#fff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 'var(--button-border-radius)',
        },
        outlined: ({ theme, ownerState }) => {
          // @ts-ignore
          const paletteColor: PaletteColor = theme.palette[ownerState.color] || theme.palette.primary;
          return {
            color: paletteColor.main,
            borderColor: paletteColor.main,
            '&:hover': {
              color: paletteColor.contrastText,
              borderColor: paletteColor.main,
              backgroundColor: paletteColor.main,
            },
          };
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: 'var(--common-color-primary)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          textAlign: 'start',
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--common-color-dark)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--common-color-primary)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--common-color-primary)',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          textAlign: 'start',

          '&.Mui-focused': {
            color: 'var(--common-color-dark)',
          },
        },
        asterisk: {
          color: 'var(--common-color-red)',
        },
      },
    },
  },
});
